module.exports = __webpack_public_path__ + "img/turn-down.0aceafdf.svg";